import { InstagramIcon } from '@/components/svg/instagram-icon/instagram-icon'
import { VideoIcon } from '@/components/svg/video-icon/video-icon'
import {
  BadgeIcon,
  ButtonIcon,
  ColumnsIcon,
  EmbedIcon,
  ImagesGrid,
  LandingPage,
  QuoteIcon,
  SingleImage,
} from '@/components/v1/page-style/admin/editor-console/content/widget/widget.style'

export const widgetsData = [
  {
    section: 'Basic',
    disabled: false,
    collections: [
      { name: 'Text/HTML', type: 'content', Icon: EmbedIcon, disabled: false },
      { name: 'Column', type: 'column', Icon: ColumnsIcon, disabled: false },
      { name: 'Button', type: 'button', Icon: ButtonIcon, disabled: false },
    ],
  },
  {
    section: 'Templates',
    disabled: false,
    collections: [
      {
        name: 'Single Image',
        type: 'single_image',
        Icon: SingleImage,
        disabled: false,
      },
      {
        name: 'Image Grid',
        type: 'image_grid',
        Icon: ImagesGrid,
        disabled: false,
      },
      { name: 'Quote', type: 'quote', Icon: QuoteIcon, disabled: false },
      { name: 'CTA', type: 'cta', Icon: BadgeIcon, disabled: false },
      {
        name: 'Supplier Reference',
        type: 'featured_suppliers',
        Icon: LandingPage,
        disabled: false,
      },
      {
        name: 'Video',
        type: 'embedded_video',
        Icon: VideoIcon,
        disabled: false,
      },
      {
        name: 'Instagram Embed',
        type: 'embedded_instagram',
        Icon: InstagramIcon,
        disabled: false,
      },
    ],
  },
]

export const widgetIndex = {
  content: 1,
  image_grid: 2,
  quote: 3,
  column: 5,
  featured_suppliers: 6,
  cta: 7,
  html: 8,
  single_image: 9,
  podcast: 10,
  banner: 11,
  button: 12,
  embedded_video: 13,
  embedded_instagram: 14,
} as any
